import { mapActions, mapGetters, mapMutations } from 'vuex';
import checkUserVerification from '@/mixins/checkUserVerification';

export default {
  mixins: [checkUserVerification],
  computed: {
    ...mapGetters({
      partnerUrl: 'profile/externalPartner/partnerUrl',
      userToken: 'profile/externalPartner/userToken',
      clientId: 'profile/externalPartner/clientId',
      productCode: 'profile/externalPartner/productCode',
      tokenValid: 'profile/externalPartner/tokenValid'
    })
  },
  methods: {
    ...mapMutations({
      setPartnerUrl: 'profile/externalPartner/setPartnerUrl',
      setUserToken: 'profile/externalPartner/setUserToken',
      setClientId: 'profile/externalPartner/setClientId',
      setProductCode: 'profile/externalPartner/setProductCode',
      setCheckTokenLoading: 'profile/externalPartner/setCheckTokenLoading'
    }),

    ...mapActions({
      resetExternalPartner: 'profile/externalPartner/resetExternalPartner',
      checkRegistrationToken: 'profile/externalPartner/checkRegistrationToken',
      setCheckTokenLoading: 'profile/externalPartner/setCheckTokenLoading',
      setExternalRegistrationDialog: 'profile/externalPartner/setExternalRegistrationDialog',
      setAuthorizationDialogShown: 'profile/dashboard/setAuthorizationDialogShown'
    }),

    async loadUserDataFromQuery() {
      if (
        this.$route.query.userToken &&
        (this.$route.query.partnerUrl || this.$route.params.partnerUrl)
      ) {
        this.setPartnerUrl(this.$route.query.partnerUrl || this.$route.params.partnerUrl);
        this.setUserToken(this.$route.query.userToken);
      }
      if (this.$route.query.clientId) {
        this.setClientId(this.$route.query.clientId);

        if (this.$route.query.hash) {
          this.setPartnerUrl('drmax');
          this.setUserToken(this.$route.query.hash);
        }
      }

      if (this.$route.query.productCode) {
        this.setProductCode(this.$route.query.productCode);
      }
    },

    async checkExternalAuthorization() {
      if (this.tokenValid === null && !!this.partnerUrl && !!this.userToken) {
        if (this.partnerUrl === 'pvzp') {
          await this.$http
            .post('/v3/fe/web-users/prolong-benefit', {
              clientId: this.clientId,
              partnerUrl: this.partnerUrl,
              userToken: this.userToken,
              productCode: this.productCode,
              region: this.$domainRegion
            })
            .then(async () => {
              this.setAuthorizationDialogShown(true);
              await this.$auth.fetchUser();
            })
            .catch(err => {
              this.handleError({ error: err, code: '0x0000002F' });
              this.resetExternalPartner();
            })
            .finally(async () => {
              this.setExternalRegistrationDialog(false);
              this.setCheckTokenLoading(false);
              if (this.$auth.isLoggedIn) {
                await this.activateExternalBenefit();
                await this.checkUserVerification();
              }
            });
        }

        await this.checkRegistrationToken(this.$domainRegion);
      }
    },

    async activateExternalBenefit() {
      if (!!this.partnerUrl && !!this.userToken && !!this.tokenValid) {
        await this.activateBenefit({ user: this.$auth.user, dynamicForm: this.$route.query.dfn });
        if (this.$auth.isLoggedIn) {
          await this.checkUserVerification();
        }
      }
    },
    async activateBenefit() {
      this.setCheckTokenLoading(true);
      this.setExternalRegistrationDialog(true);
      await this.$http
        .post('/v2/activate-benefit', { userToken: this.userToken })
        .then(async () => {
          await this.resetExternalPartner(); //can't be moved to finally because of commands order
          this.setAuthorizationDialogShown(true);
          await this.$auth.fetchUser();
          this.gtmPush({
            event: 'client_type_authorized',
            'client.type': this.partnerData?.name,
            'event.detail': 'success'
          });
        })
        .catch(async err => {
          await this.resetExternalPartner();
          this.handleError({ error: err, showModal: false, code: '0x00000030' });
        })
        .finally(async () => {
          this.setExternalRegistrationDialog(false);
          this.setCheckTokenLoading(false);
        });
    }
  }
};
